var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":"","dense":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('StandardChart',{attrs:{"input":_vm.totalData,"max-width":"100%"}})],1),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('StandardChart',{attrs:{"input":_vm.countData,"max-width":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }